import { useAppSelector } from 'store/store-hooks';
import cm from 'classnames';

import { SrPlayer } from 'components/app/selector/selector-player/sr-player';
import { SelectorFiles } from 'components/app/selector/selector-files/selector-files';
import { SelectorClipsGrid } from 'components/app/selector/selector-clips/selector-clips-grid';
import { SelectorStats } from 'components/app/selector/selector-stats/selector-stats';
import { EditorActions } from 'components/app/editor/editor-actions/editor-actions';

import styles from './_app-layout.module.scss';

export const AppLayoutSr = () => {
  const configPanel = useAppSelector((state) => state.editor.configPanel);

  return (
    <div className={cm(styles.Selector, { [styles['Selector--side']]: configPanel === 'clip' })}>
      <div className={styles.Selector__side}>
        <div className={styles.Selector__sideNested}>
          <SelectorFiles />
        </div>
      </div>
      <div className={styles.Selector__main}>
        <div className={styles.Selector__header}>
          <SrPlayer />
          <EditorActions className={styles.Selector__actions} />
          <SelectorStats />
        </div>
        <SelectorClipsGrid />
      </div>
    </div>
  );
};
